export default __webpack_public_path__ + "static/media/facebook_privacy_en.a3e3f3c0.svg";